import { AbtestType } from "@/graphql";

export function formatAbTestType(treatmentTypes: AbtestType[]): AbtestType {
  if (treatmentTypes && treatmentTypes.length > 0) {
    return treatmentTypes[0];
  }
  return AbtestType.Class;
}
